import React, { lazy, Suspense } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import UpgradePrompt from './UpgradePrompt';

const ProMaxWall = lazy(() => import('./single-stocks/ProMaxWall'));

const ProRoute = ({ feature, children }) => {
  const { hasFeature, loading } = useSubscription();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!hasFeature(feature)) {
    // Show Pro Max wall for single_stocks, regular upgrade prompt for everything else
    if (feature === 'single_stocks') {
      return <Suspense fallback={<div />}><ProMaxWall /></Suspense>;
    }
    return <UpgradePrompt feature={feature} />;
  }

  return children;
};

export default ProRoute;
